import { QuestionTypeChip } from '@exam-management/components';
import { QuestionGroupType } from '@exam-management/graphql';
import { Text, Chip, EllipsisText, type GridColDef } from '@shared/components';
import { formatDateTime } from '@shared/utils';

export interface Question {
  id: string;
  code: string;
  questionGroupType: QuestionGroupType;
  subQuestionCount?: number;
  itemSetName?: string;
  questionIds?: string[];
  createdBy: {
    name: string;
    email: string;
  };
  updateAt: Date;
}

export const columns: GridColDef<Question>[] = [
  {
    field: 'code',
    headerName: 'QID',
    width: 210,
    sortable: false,
    renderCell: ({ row }) => {
      return <EllipsisText>{row.code}</EllipsisText>;
    },
  },
  {
    field: 'qType',
    headerName: 'QType',
    width: 110,
    sortable: false,
    renderCell: ({ row }) => {
      if (row.questionGroupType === QuestionGroupType.Single) {
        return <QuestionTypeChip type='single' />;
      }
      return (
        <Chip
          label={<Text variant='captionSemibold'>Item Set: {row.subQuestionCount}Q</Text>}
          size='small'
          sx={(theme) => ({
            backgroundColor: theme.palette.info.light,
            minWidth: '62px',
          })}
        />
      );
    },
  },
  {
    field: 'itemSetName',
    headerName: 'Item Set Name',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) => {
      return <EllipsisText>{row.itemSetName ?? '-'}</EllipsisText>;
    },
  },
  {
    field: 'createBy',
    headerName: 'Created By',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) =>
      row.questionGroupType === QuestionGroupType.ItemSet ? (
        '-'
      ) : (
        <EllipsisText>{row.createdBy.name}</EllipsisText>
      ),
  },
  {
    field: 'updateAt',
    headerName: 'Last Modified',
    width: 160,
    sortable: false,
    renderCell: ({ row }) => {
      return <EllipsisText>{formatDateTime(row.updateAt)}</EllipsisText>;
    },
  },
];
